import { render, staticRenderFns } from "./output_detail.vue?vue&type=template&id=8bdd7440&scoped=true"
import script from "./output_detail.vue?vue&type=script&lang=js"
export * from "./output_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdd7440",
  null
  
)

export default component.exports